"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.on = on;
exports.emit = emit;
function on(event, cb) {
    var subscribers = _extends({}, this.subscribers);
    if (!subscribers[event]) {
        subscribers[event] = [];
    }
    subscribers[event].push(cb);
    this.subscribers = subscribers;

    return this;
}

function emit(event) {
    var _this = this;

    for (var _len = arguments.length, payload = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        payload[_key - 1] = arguments[_key];
    }

    if (this.subscribers[event]) {
        this.subscribers[event].map(function (cb) {
            return cb.apply(_this, payload);
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/slider/event-hooks.js
// module id = ./resources/assets/js/src/slider/event-hooks.js
// module chunks = 0